// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-1a04d083] {\n  display: inline-block;\n  vertical-align: baseline;\n}\n", ""]);
// Exports
module.exports = exports;
